import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { usePwaInstall } from './pwa';

const DISMISS_KEY = 'rastamen_install_dismissed';

export default function InstallPrompt() {
  const { pathname } = useLocation();
  const { canInstall, standalone, ios, promptInstall } = usePwaInstall();
  const [dismissed, setDismissed] = useState(true); // localStorage okunana dek gizli (flaş olmasın)

  useEffect(() => {
    try { setDismissed(Boolean(localStorage.getItem(DISMISS_KEY))); } catch { setDismissed(false); }
  }, []);

  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch { /* yoksay */ }
  };
  const install = async () => {
    await promptInstall();
    dismiss();
  };

  const showAndroid = canInstall;          // beforeinstallprompt yakalandı
  const showIos = ios && !standalone;      // iOS'ta otomatik prompt yok → ipucu
  // Randevu adımlarında alttaki sabit aksiyon barıyla çakışmasın diye gizle.
  const visible = !standalone && !dismissed && pathname !== '/randevu' && (showAndroid || showIos);
  if (!visible) return null;

  return (
    <div className="install-banner" role="dialog" aria-label="Uygulamayı yükle">
      <img src="/icon-192.png" alt="" className="install-banner-icon" />
      <div className="install-banner-body">
        <strong>Rastamen Lounge</strong>
        <span>
          {showAndroid
            ? 'Ana ekrana ekle, uygulama gibi tek dokunuşla aç.'
            : 'Paylaş ⬆ → “Ana Ekrana Ekle” ile uygulama gibi aç.'}
        </span>
      </div>
      {showAndroid && (
        <button type="button" className="install-banner-btn" onClick={install}>Yükle</button>
      )}
      <button type="button" className="install-banner-close" onClick={dismiss} aria-label="Kapat">×</button>
    </div>
  );
}
